import { Controller } from "@hotwired/stimulus"
import "@selectize/selectize"

export default class extends Controller {
  static get targets() {
    return ["select", "tagsContainer", "tagTemplate", "tag"]
  }

  connect() {
    this.selectizeElement = $(this.selectTarget).selectize({
      persist: false,
      create: false,
      copyClassesToDropdown: false,
      onItemAdd: (value, $item) => {
        this.renderItem(value, $item[0].innerText)
      },
      onItemRemove: (value) => {
        let tagToRemove = this.tagsContainerTarget.querySelector(`[data-value="${value}"]`)

        if (tagToRemove) {
          this.tagsContainer.removeChild(tagToRemove)
        }
        this._refreshPlaceholder()
      },
      onChange: () => {
        this._dispatchChangeEvent()
      },
      render: {
        // We render items outside the select so we have to use this custom render function
        item: (item, escape) => {
          return `<div style="display:none;">${escape(item.text)}</div>`
        },
      },
    })
    Array.from(this.selectTarget.options).forEach((option) => {
      if (option.selected) {
        this.renderItem(option.value, option.innerText)
      }
    })
  }

  disconnect() {
    // Destroy the Selectize element to avoid duplication of the field
    if (this.selectizeElement.length > 0) {
      this.selectizeElement[0].selectize.destroy()
    }
  }

  renderItem(value, label) {
    let tagHtml = this.tagTemplateTarget.innerHTML
    tagHtml = tagHtml.replace(/%LABEL%/g, label)
    tagHtml = tagHtml.replace(/%VALUE%/g, value)
    let tagNode = document.createElement("div")
    tagNode.innerHTML = tagHtml
    this.tagsContainerTarget.appendChild(tagNode.firstElementChild)
    this._refreshPlaceholder()
  }

  removeTag(event) {
    let value = event.params.value
    // Remove tag under the select box
    this.tagTargets.find((tag) => tag.dataset.value === value)?.remove()
    // Sync change to selectize
    this.selectTarget.selectize.removeItem(value)
  }

  // Below function needs to be used whenever we change item state of selectize input so make sure
  // we always show the placeholder
  _refreshPlaceholder() {
    const selectizeInput = this.selectTarget.selectize.$control_input[0]
    selectizeInput.setAttribute("placeholder", this.selectTarget.attributes.placeholder.value)
    selectizeInput.style.width = "inherit"
    selectizeInput.style.height = "100%"
  }

  _dispatchChangeEvent() {
    this.dispatch("change", {})
  }
}
